import React from "react";
import { Link } from "react-router-dom";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import MarketingBackdrop, { panelClass, softPanelClass, ctaSectionClass } from "../components/MarketingBackdrop";

const products = [
  {
    title: "Neo",
    tag: "Operations engine",
    desc: "Neo handles live operations, clock-ins, duties, workflows, incidents, and visibility across your industry mode.",
    to: "/#neo",
  },
  {
    title: "Morphius Count",
    tag: "Stock count system",
    desc: "Morphius Count brings structured counting, variance validation, imports, and reporting into MatrixOS.",
    to: "/morphius-count",
  },
];

export default function Products() {
  return (
    <MarketingBackdrop>
      <SiteHeader active="products" />
      <main className="relative px-6 pb-20 pt-32">
        <div className="mx-auto max-w-6xl">
          <div className="mx-auto max-w-4xl text-center">
            <div className="mb-3 text-xs uppercase tracking-[0.28em] text-cyan-300">MatrixOS product story</div>
            <h1 className="text-4xl font-extrabold leading-[1.02] md:text-6xl">Two products. One platform direction.</h1>
            <p className="mt-5 text-lg leading-8 text-slate-300">
              MatrixOS is the platform layer. Neo runs the operation. Morphius Count runs the stock counting side. Both sit inside one clean system story.
            </p>
          </div>

          <div className="mt-12 grid gap-6 md:grid-cols-2">
            {products.map((item) => (
              <Link key={item.title} to={item.to} className={`${panelClass} p-7 transition hover:-translate-y-1`}>
                <div className="text-xs uppercase tracking-[0.22em] text-cyan-300">{item.tag}</div>
                <div className="mt-3 text-3xl font-extrabold">{item.title}</div>
                <p className="mt-4 min-h-[110px] leading-7 text-slate-200/85">{item.desc}</p>
                <div className="mt-6 font-medium text-cyan-200">View direction →</div>
              </Link>
            ))}
          </div>

          <section className="mt-16 grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
            <div className={`${panelClass} p-8 md:p-10`}>
              <div className="mb-3 text-sm uppercase tracking-[0.22em] text-cyan-300">Why this matters</div>
              <h2 className="text-3xl font-bold">Keep the brand simple. Keep the product story clear.</h2>
              <p className="mt-4 max-w-3xl leading-8 text-slate-300">
                MatrixOS is the umbrella platform. Neo is the operational engine teams use every day. Morphius Count is the stock count product inside the same world. That gives you room to scale into more industries without confusing the story.
              </p>
              <div className="mt-7 flex flex-wrap gap-4">
                <Link to="/book-demo" className="rounded-full bg-cyan-400 px-6 py-3 font-semibold text-[#071120] transition hover:bg-cyan-300">Book demo</Link>
                <Link to="/contact" className="rounded-full border border-cyan-400/70 bg-cyan-400/5 px-6 py-3 transition hover:bg-cyan-400/12">Talk it through</Link>
              </div>
            </div>
            <div className={`${softPanelClass} p-8`}>
              <div className="mb-3 text-sm uppercase tracking-[0.22em] text-cyan-300">Current focus</div>
              <ul className="space-y-4 leading-7 text-slate-200/90">
                <li>• Neo for operations across retail, security, sport, and warehousing</li>
                <li>• Morphius Count for next-generation stock counts inside MatrixOS</li>
                <li>• Clearer brand structure before adding future modules</li>
              </ul>
            </div>
          </section>

          <section className={`mt-16 ${ctaSectionClass} p-8 text-center md:p-10`}>
            <div className="mx-auto mb-3 w-fit rounded-full bg-cyan-400/10 px-4 py-1.5 text-[0.72rem] uppercase tracking-[0.26em] text-cyan-200">Platform positioning</div>
            <h2 className="text-3xl font-bold">Lead with pain. Then show control. Then show the system.</h2>
            <p className="mx-auto mt-4 max-w-3xl leading-8 text-slate-200/90">
              That gives MatrixOS a stronger commercial story and helps clients immediately understand where Neo and Morphius Count fit.
            </p>
          </section>
        </div>
      </main>
      <SiteFooter />
    </MarketingBackdrop>
  );
}
